// extracted by mini-css-extract-plugin
export default {"primary":"#001529","white":"#ffffff","azure":"#5470c6"};